import WebGLTileClass, * as WebGLTileModule from './../../node_modules/ol/layer/WebGLTile.js';

// Create a wrapper class
class WebGLTile extends WebGLTileClass{
    constructor(options) {
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in WebGLTileModule) {
    if (key !== "default") {
        WebGLTile[key] = WebGLTileModule[key];
    }
}

export default WebGLTile;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/layer/WebGLTile.js';